import { useSetAtom } from 'jotai';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { MaggieFeatureFlags } from '../../../util/feature-flags';
import { formulaFieldsEnabledAtom } from './FormulaFieldsStateJ';

/**
 * Bridges the showFormulaFields LD flag into jotai so non-React consumers
 * (metrics atoms, MetricsCalculator) share one kill switch with the UI.
 * Renders nothing; mount once inside the LD provider.
 */
export function FormulaFieldsFlagSync() {
  const { showFormulaFields } = useFlags<MaggieFeatureFlags>();
  const setEnabled = useSetAtom(formulaFieldsEnabledAtom);

  useEffect(() => {
    setEnabled(Boolean(showFormulaFields));
  }, [showFormulaFields, setEnabled]);

  return null;
}
